import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'encomply-snackbar-messages',
    templateUrl: './encomply-snackbar-messages.component.html',
    styleUrls: ['./encomply-snackbar-messages.component.scss'],
    standalone: false,
})
export class EnComplySnackbarMessagesComponent implements OnInit {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data) {}

    ngOnInit() {}
}
